var collection_videos = {
	wool: '378916693',
	straw: '391096611',
	trim: '391096656',
	felt: '391096565'
}

jQuery(function ($) {
	var $body = $('body');

	var players = {};
	var active_player;

	/*$('a[href*=vimeo]').not('[data-section-type="slideshow"] a').each(function () {
		var video_id = this.href.replace('https://vimeo.com/', '');

		if (players[video_id]) return;

		var popup = $('<div class="popup popup-video popup-'+video_id+'">\
			<figure>\
				<iframe src="https://player.vimeo.com/video/'+video_id+'"></iframe>\
			</figure>\
		</div>');

		$body.append(popup);

		var iframe = document.querySelector('iframe[src*="'+video_id+'"]');
		players[video_id] = new Vimeo.Player(iframe);
	}).click(function (e) {
		e.preventDefault();

		var video_id = this.href.replace('https://vimeo.com/', '');
		var popup = $('.popup-'+video_id);

		popup.addClass('in');

		active_player = players[video_id];
		active_player.play();
	}).addClass('with-video');*/

	$('[data-section-type="slideshow"] a, [data-section-type="text-over-image"] a').each(function () {
		var video_id;

		if (this.href.indexOf('vimeo.com') >= 0) {
			video_id = this.href.replace('https://vimeo.com/', '');
		} else if (this.hash.indexOf('#video-') >= 0) {
			video_id = collection_videos[this.hash.replace('#video-', '')];
		}

		if (!video_id) return;

		var $this = $(this);

		$this.append(
			$('<div class="banner_video"><iframe class="video-bg" src="https://player.vimeo.com/video/'+video_id+'?background=1"></iframe></div>')

		);

		var iframe = this.querySelector('iframe[src*="'+video_id+'"]');
		var player = new Vimeo.Player(iframe);

		$this.click(function (e) {
			e.preventDefault();

			player.getPaused().then(function(paused) {
				if (paused) {
					player.play();
					$this.removeClass('paused');
				} else {
					player.pause();
					$this.addClass('paused');
				}
			});

			$this.addClass('playing');
          	$('.slide .overlay-type').addClass('hide_this');
		});

		if (location.pathname == '/' && $this.parents('.shopify-section').is(':first-child')) {
			$this.addClass('playing');
			$this.find('.button').remove();
		} else {
			player.pause();
		}
	}).addClass('with-video');

	$('.popup').click(function (e) {
		if (e.target != this) return;
		$(this).removeClass('in');
		active_player.pause();
	});
});